import { fg } from '@confluence/feature-gating';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { preloadSpacesList } from '@confluence/space-utils/entry-points/preloadSpacesList.ts';
import { getRemoteLocalStorage } from '@confluence/storage-manager/entry-points/getRemoteLocalStorage.ts';

export async function preloadAdvancedSearchRoute(
	match: RouteMatch,
): Promise<void | any[] | Error[]> {
	const tasks: Promise<any>[] = [];

	const preloadedSessionContext = getPreloaderFnContext();
	const { accessStatus, cloudId, userId, isRovoEnabled } = preloadedSessionContext;

	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;

	tasks.push(preloadSpacesList({ isLicensed }));

	const isFullPageSearchEnabled =
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		(fg('unified_search_in_confluence') || isRovoEnabled) && !fg('confluence_rovo_search_opt_out');

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR && isFullPageSearchEnabled) {
		const remoteLocalStoragePromise = getRemoteLocalStorage({ userId, isLicensed });
		void import(
			/* webpackChunkName: "loadable-search-route-preloader" */
			'@confluence/search-route-preloader/entry-points/preloadSearch.ts'
		)
			.then(({ preloadSearch }) => {
				preloadSearch({
					cloudId,
					userId,
					remoteLocalStoragePromise,
					queryParams: match.query,
				});
			})
			.catch(() => null);
	}

	return waitForAllReturnWhenError(tasks);
}
